var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4142 0H5.00024C4.20459 0 3.44153 0.31607 2.87892 0.87868C2.31631 1.44129 2.00024 2.20435 2.00024 3V24H22.0002V7.586L14.4142 0ZM15.0002 3.414L18.5862 7H15.0002V3.414ZM4.00024 22V3C4.00024 2.73478 4.1056 2.48043 4.29314 2.29289C4.48067 2.10536 4.73503 2 5.00024 2H13.0002V9H20.0002V22H4.00024ZM15.2932 13.122L16.7072 14.536L13.1212 18.121C12.8427 18.3996 12.5119 18.6207 12.1479 18.7715C11.7839 18.9222 11.3938 18.9999 10.9997 18.9999C10.6057 18.9999 10.2156 18.9222 9.85158 18.7715C9.48757 18.6207 9.15683 18.3996 8.87824 18.121L7.29324 16.536L8.70724 15.122L10.2932 16.707C10.4836 16.889 10.7369 16.9906 11.0002 16.9906C11.2636 16.9906 11.5169 16.889 11.7072 16.707L15.2932 13.122Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsFileCheck);
export default __webpack_public_path__ + "static/media/fi-rs-file-check.87f8687f9fb8ac8c0d1b7ded9c3babdb.svg";
export { ForwardRef as ReactComponent };